export default {
  studio_auth: '工作室认证',
  studio_auth_type: '认证类型',
  studio_auth_choose_type: '请选择认证类型:',
  studio_auth_cooper: '合作伙伴企业认证',
  studio_auth_internal: '内部工作室认证',
  studio_auth_project_name: '项目名称',
  studio_auth_project_owner: '项目负责人',
  company_auth: '企业认证',
  how_company_auth: '如何进行工作室认证',
  how_studio_auth: '如何认证',
  company_auth_desc:
    '请先根据您的项目类型选择对应的认证方式:<br />若您的项目为腾讯公司内部自研、二方合作及代理发行的项目，请选择“内部工作室认证”；<br />若您的项目属于外部战略合作企业相关业务，请选择“合作伙伴企业认证”。',
  company_auth_external_desc:
    'InGame目前仅为战略合作企业提供服务，为保证您的财产安全，进行在线充值与合同签署前均需完成企业认证。一个工作室仅能认证一个企业，该认证结果将直接影响账号和服务资源的归属。',
  company_auth_internal_desc:
    'InGame 为确保费用核算数据准确性，各工作室需完成项目认证。一个工作室仅能关联一个内部项目及对应的 KPICode。',
  company_auth_info: '将在3-5个工作日内反馈审核结果，敬请耐心等候！',
  company_start_auth: '立即认证',
  company_re_auth: '重新认证',
  company_modify_auth: '修改认证',
  company_reject_title: '您提交的材料有以下错误',
  company_reject_text: '未通过校验',
  company_view_doc: '查看文档',
  company_reject_mdm: '公司名称或社会信用代码',
  company_no_auth: '尚未认证',
  company_status_pending: '认证材料审核中',
  company_status_resolve: '已认证',
  company_status_reject: '认证未通过',

  company_cooper: '合作主体：深圳市腾讯计算机系统有限公司',
  company_basic_info: '企业基础信息',
  company_name: '企业名称',
  company_area: '认证地区',
  company_area_cn: '中国大陆',
  company_area_info: '如有非大陆地区认证的需求，请联系我们人工处理。',
  company_info: '企业信息',
  company_desc: '企业简介',
  company_cert: '企业组织证件',
  company_credit_code: '社会信用代码',
  company_credit_code_info:
    '对中华人民共和国内依法注册、依法登记的机关、企事业单位、社会团体，以及其他组织机构颁发一个在全国范围内唯一的、始终不变的代码标识。若无则填写商业证件号或者其他组织机构代码。',

  company_input_wrong: '输入格式不正确',

  company_license: '营业执照',
  company_contact_man: '企业联系人',
  company_contact_name: '姓名',
  company_contact_id: '身份证号',
  company_contact_phone: '手机号码',
  company_uploading_cert: '正在上传',
  company_upload_warn: '上传最新营业执照 (jpg或png格式)，不超过4M',
  company_upload_err: '上传的营业执照不超过4M',
  company_status_error_warn: '帐户状态异常，无法进行该操作',
};
